import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

/**
 * @example
 * <input type="date" data-controller="datepicker">
 */
export class DatepickerController extends Controller {
  #flatpickr;

  connect() {
    this.#flatpickr = flatpickr(this.element, {
      locale: Japanese,
      // static: true, // これを指定するとconnectが無限に呼ばれる
      dateFormat: "Y/m/d",
      allowInput: true,
    });
  }

  disconnect() {
    if (!this.#flatpickr) return;
    this.#flatpickr.destroy();
  }
}
